import { makeService } from './api';

const service = makeService('bank_accounts');

export default service;